'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import { useRouter } from 'next/navigation';
import style from './Tab.module.scss';
const Tab = t0 => {
  const $ = _c(14);
  const {
    text,
    link,
    mobTabActiveStyle,
    mobTabStyle,
    mobTabBehindStyle,
    disabled,
    hide,
    isActive,
    isBehind
  } = t0;
  const router = useRouter();
  if (hide) {
    return null;
  }
  let t1;
  if ($[0] !== isActive || $[1] !== isBehind || $[2] !== mobTabActiveStyle || $[3] !== mobTabBehindStyle || $[4] !== mobTabStyle) {
    const getStyles = () => {
      switch (true) {
        case isActive:
          {
            return cn(style.tab__active, mobTabActiveStyle);
          }
        case !isActive && !isBehind:
          {
            return cn(style.tab, mobTabStyle);
          }
        case !isActive && isBehind:
          {
            return cn(style.tab__behind, mobTabBehindStyle);
          }
        default:
          {
            return "";
          }
      }
    };
    t1 = getStyles();
    $[0] = isActive;
    $[1] = isBehind;
    $[2] = mobTabActiveStyle;
    $[3] = mobTabBehindStyle;
    $[4] = mobTabStyle;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== link || $[7] !== router) {
    t2 = () => router.push(link);
    $[6] = link;
    $[7] = router;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== disabled || $[10] !== t1 || $[11] !== t2 || $[12] !== text) {
    t3 = <button className={t1} disabled={disabled} onClick={t2}>{text}</button>;
    $[9] = disabled;
    $[10] = t1;
    $[11] = t2;
    $[12] = text;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
export default Tab;